import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import { useNavigate } from 'react-router-dom';
import BreadCrumbs from '../BreadCrumbs';
import CircleImage from "olive-react-myoneui/lib/CircleImage";
import { bookhalfIcon, calendarsIcon, certiIcon, clockIcon, coursesIcon, homeIcon, emplyArrow, leftArrowLong } from "../../../constants/icons";
import IntroCard from '../card/IntroCard';
import IntroCardImage from "../../../../assets/img/sample2.jpg";
import Tab from 'olive-react-myoneui/lib/Tab';
import Nav from 'olive-react-myoneui/lib/Nav';

import Button from "olive-react-myoneui/lib/Button";
import Toast from "olive-react-myoneui/lib/Toast";
import ToastInfo from "olive-react-myoneui/lib/ToastInfo";

import lectureImage from '../../../../assets/img/sample.png';
import sampleImage from '../../../../assets/img/sample.png';
import CourseProgressAccordion from './ArchiveProgressAccordion';
import CourseQandA from './ArchiveQandA';
import CourseReport from './ArchiveReport';
import TestJourney from './TestJourney';
import CourseAnnouncements from './ArchiveAnnouncements';
import CoursePlay from './ArchivePlay';
import sampleVideo from "../../../../assets/img/google_ai_course.mp4";
import { getArchivedContents } from '../../../../api/afterLogin/archives';
import { pluralize } from '../../../../helpers/string_helper';
import { formatDaysAgo } from '../../../../helpers/datetime_helper';
import { imageSrc } from '../../../../helpers/url_helper';
import Modal from 'olive-react-myoneui/lib/Modal';
import Error403 from '../../../../modules/Error403';
import { checkDisabledSp } from '../../../../helpers/permission_helper';
import { getEnrolledSubjectReport } from '../../../../api/afterLogin/courses';

const ArchiveDetails = ({ className }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const navigate = useNavigate();
  const adminData  = useSelector((state) => state.admin);
  const configData = useSelector((state) => state.config);
  const [courseContent, setCourseContent] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [announcement, setAnnouncement] = useState([]);
  const [totalVideoHours, setTotalVideoHours] = useState([]);
  const [sections, setSections] = useState([]);
  const [lectures, setLectures] = useState([]);
  const [lectureLog, setLectureLog] = useState([]);
  const [quiz, setQuiz] = useState([]);
  const [progressReport, setProgressReport] = useState([]);
  const [hasCertificate, setHasCertificate] = useState([]);
  const [showEmptyItemBlock, setShowEmptyItemBlock] = useState(false);
  const paths = useSelector((state) => state.user.paths);
  const [showCertificate, setShowCertificate] = useState(false);

  /* ACCESS CHECK */
  const products  = adminData.products;
  const userSpEnabled = adminData?.user_sp_enabled;
  const [noAccess, setNoAccess] = useState(checkDisabledSp('mykademy', products, userSpEnabled));

  const { id } = useParams();

  const fetchContents = async (params) => {
    const payload = {
      accessToken: configData.access_token,
      id: params
    }
    const allEnrolledCourses = await getArchivedContents(payload);
    if (allEnrolledCourses) {
      setIsLoading(false);
      const data = allEnrolledCourses;
      setCourseContent(data?.data);
      setAnnouncement(data?.data?.announcements);
      setSections(data?.data?.csa_section_details ? JSON.parse(data?.data?.csa_section_details) : []);
      setLectures(data?.data?.csa_lecture_details ? JSON.parse(data?.data?.csa_lecture_details) : []);
      setLectureLog(data?.data?.csa_cs_lecture_log ? JSON.parse(data?.data?.csa_cs_lecture_log) : []);
      setQuiz(data?.data?.csa_aa_assessment_attempts_details? JSON.parse(data?.data?.csa_aa_assessment_attempts_details) : []);
      setTotalVideoHours(hourSplit(data.data?.cb_total_video_hours));
      setProgressReport(data?.data?.csa_sr_subject_report_details ? JSON.parse(data?.data?.csa_sr_subject_report_details) : []);
      setHasCertificate(data?.data?.cb_has_certificate ?? 0);
      setShowEmptyItemBlock(true);
    }
  };

  useEffect(() => {
    setShowEmptyItemBlock(false);
    fetchContents(id);
  }, [id]);

  const coursePages = [
    { icon: homeIcon, label: "Home", url: "/" },
    { icon: coursesIcon, label: "Archives", url: "/student-dashboard/archives" },
    { label: courseContent?.csa_cs_course_tittle }
  ];

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

 
  const hourSplit = (param) => {
    if (!param || param === '0') return 0;
    const combination  = param?.split('-');
    if (!combination[0]) return 0;    
    if (combination[1] === 'hours') {
      return pluralize(parseInt(combination[0]), 'hour', true);
    } else {
      // minutes
      const minutes = parseInt(combination[0]);
      if (minutes > 60) {
        return pluralize(Math.floor(minutes / 60), 'hour', true) + ' ' + pluralize(minutes % 60, 'minute', true);
      } else {
        return pluralize(minutes, 'minute', true);
      }
    }
  }

  const formatDate = (dateString) => {
    if (!dateString || dateString === '0000-00-00' || dateString === '0000-00-00 00:00:00') {
      return 'N/A';
    }
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit'
    });
  };


  const courseOverviewData = {
    courseDescDetails: {
      title: courseContent?.csa_cs_course_tittle,
      description: courseContent?.cb_description ? courseContent?.cb_description : '',
      descriptionLength: courseContent?.cb_description ? (courseContent?.cb_description.replace(/<[^>]+>/g, "")).length : 0,
      backIcon: leftArrowLong,
    },
    instructorDetails: courseContent?.tutors,
    objectives: courseContent?.cb_what_u_get ? JSON.parse(courseContent?.cb_what_u_get) : [],
    courseDetails: [
      { icon: bookhalfIcon, label: pluralize(courseContent?.lecture_count, 'Lecture', false), value: courseContent?.lecture_count },
      { icon: calendarsIcon, label: "Course Validity", value: courseContent?.csa_lcrta_reset_result !== 1 && courseContent?.csa_lcrt_certificate_url ? courseContent?.csa_lcrta_expired_date === null || courseContent?.csa_lcrta_expired_date === '' ? 'N/A' : courseContent?.csa_lcrta_expired_date === 'unlimited' ? 'Unlimited' : formatDate(courseContent?.csa_lcrta_expired_date) : 'N/A', },
      { icon: emplyArrow, label: "Learning" }, 
      { icon: certiIcon, label: "Certificate of completion" },
      { icon: clockIcon, label: "Total Duration", value: totalVideoHours }
    ]
  };

  const lectureData = sections && sections?.map((section) => {
    const relatedLectures = lectures && lectures
      .filter((lecture) => lecture.section_id === section.id)
      .map((lecture) => {
        const log = lectureLog?.[lecture.id] || {};
        return {
          courseId: courseContent?.csa_cs_course_id,
          lectureId: lecture.id,
          title: lecture.lecture_name,
          showAttempts: lecture.cl_lecture_type !== 3 ? 'disable' : 'enable',
          showProgressBar: lecture.cl_lecture_type !== 4 ? 'disable' : 'enable',
          progressPercentage: log?.percentage,
          attempts: log?.views,
          status: parseInt(log?.percentage) === 100 ? 'completed' : (parseInt(log.percentage) > 0 && parseInt(log?.percentage) < 100) ? 'inprogress' : 'notStarted',
          subTopics: [],
        }
      });
    
    const totalDuration = relatedLectures.reduce((sum, lecture) => sum + (lecture.duration || 0), 0);
    const overallStatus = relatedLectures.some(lecture => lecture.status === 'notStarted');
        
    return {
      title: section.s_name ?? section.section_name,
      duration: totalDuration,
      status: overallStatus ? 'notStarted' : 'completed',
      subTopics: relatedLectures,
    };
  });  
  
  const onRetryClick = (lecture) => {
    setIsPlaying(true);
  };

  const onStartClick = (lecture) => {
    setIsPlaying(true);
  };

  const onContinueClick = (lecture) => {
    setIsPlaying(true);
  };

  const onViewCertificateClick = () => {
    setShowCertificate(true);
  };

  const announcements = announcement?.map((announcement) => {
    return {
      id: announcement.an_id,
      title: announcement.an_title,
      posterName: announcement.us_name,
      date: formatDaysAgo(announcement.an_date),
      description: announcement.an_description,
      descriptionLength: announcement.an_description ? (announcement.an_description.replace(/<[^>]+>/g, "")).length : 0,
      imageSrc: paths.course_path + announcement.us_image
    }
  });

  const CoursesProgress = progressReport && progressReport.length > 0 && progressReport?.map((report) => {
    return {
      name: report.name,
      progress: report.percentage
    }
  });

  const handleFullScreenClick = () => {
      const body = document.body;

      if (isFullScreen) {
        body.classList.remove('myk__stu-video-fullscreen');
      } else {
        body.classList.add('myk__stu-video-fullscreen');
      }

      setIsFullScreen(!isFullScreen);
  };

  const handlePlayCourse = () => {
    console.log('play course');
  }

  const handleBackClick = () => {
    navigate('student-dashboard/archives');
  };

  const getCertificateDetails = (url) => {
    if (!url) return { url: null, type: 'invalid' };
    let updatedUrl = url.endsWith('.pdf') ? url.replace('.pdf', '.jpg') : url;
    const extension = updatedUrl.split('.').pop().toLowerCase();
    const type = ['jpg', 'jpeg', 'png'].includes(extension) ? 'image' : 'invalid';
    return { url: updatedUrl, type };
  };

  const { url: certificateUrl, type: certificateType } = getCertificateDetails(courseContent?.csa_lcrt_certificate_url);

  const maxChars = 500;
  const displayDesc = isExpanded && courseOverviewData.courseDescDetails.description !== ''
    ? courseOverviewData.courseDescDetails.description
    : courseOverviewData.courseDescDetails.descriptionLength > 500 ? `${courseOverviewData.courseDescDetails.description.substring(0, maxChars)}...` : courseOverviewData.courseDescDetails.description;

  return (
    <>
    {noAccess ? <Error403 /> : (
    <>
    <BreadCrumbs pages={coursePages} />
    <div className={`${className || ""} myk__stu-courses-wrapper myk__stu-courses_details-wrapper`}>
      <Row>
        <Col md={{ span:12, order: 0 }} lg={{ span:12, order: 0 }} xl={{ span:8, order: 0 }} className="myk__course-details-col">
            <IntroCard
                imgSrc={imageSrc('course',courseContent?.csa_cb_image, paths)}
                subTitle={courseContent?.csa_cs_course_tittle}
                initialRating="3"
                progressPercentage={courseContent?.csa_cs_percentage}
                rating={courseContent?.rating}
                courseDate={courseContent?.csa_cs_updated_date ?? courseContent?.created_date ?? ''}
                isLoading={isLoading}
                render={true}
                archive={true}
                enrollmentDate={courseContent?.csa_cs_subscription_date ? courseContent?.csa_cs_subscription_date : ''}
                completionDate={courseContent?.csa_cs_course_complete_date ? courseContent?.csa_cs_course_complete_date : ''}
                certificateStatus={(courseContent?.csa_lcrta_reset_result != 1 && courseContent?.csa_lcrt_certificate_url) ? 'Released' : 'Not Released'}
                certificateValidity={(courseContent?.csa_lcrta_reset_result != 1 && courseContent?.csa_lcrt_certificate_url) ? courseContent?.csa_lcrta_expired_date : ''}
                isCertificateOnlyArchived = {courseContent?.csa_is_certificate_only_archived}
                onPlayCourse={handlePlayCourse}
            />
            <div className="myk__stu-course-tabs_wrapper">
              <Tab.Container id="myk__stu-course-highlights" defaultActiveKey="stu_overview">
                <Row>
                  <Col sm={12}>
                    <Nav variant="pills" className="mb-3">
                      <Nav.Item>
                        <Nav.Link eventKey="stu_overview">Overview</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="stu_report">Reports</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="stu_test">Test overview</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="stu_announcement">Announcements</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content className="w-100">
                      <Tab.Pane eventKey="stu_overview" className="myk__stu-course-tab_content">
                        <div className="myk__stu-details-overview">
                        <Row>
                          <Col xl="8">
                            <div className="myk__stu-course-overview pe-lg-5">
                              <div className="myk__stu-course-about">
                                <h2>About the Course</h2> 
                                <div dangerouslySetInnerHTML={{ __html: displayDesc }} />
                                {courseOverviewData.courseDescDetails.descriptionLength > 500 && 
                                <span className="btn btn-transparent mt-3 p-0" onClick={toggleDescription}>{isExpanded ? "Show Less" : "Read More"}</span>
                                }
                                {courseOverviewData.objectives && 
                                <div className="myk_stu-course-obj">
                                  <h2>Course Objectives:</h2>
                                  <ul>
                                    {courseOverviewData.objectives.map((obj, index) => (
                                      <li key={index}>{obj}</li>
                                    ))}
                                  </ul>
                                </div>
                                }
                              </div>
                            </div>
                          </Col>
                          <Col xl="4">
                           <div className="myk__stu-instructor-wrapper px-0 px-xxl-4">
                              {courseOverviewData.instructorDetails?.length > 0 && (
                              <>
                              <h2>Instructor</h2>
                              <div class="myk__stu-presenter-list">
                                {courseOverviewData.instructorDetails && courseOverviewData.instructorDetails.map((tutor) => (
                                <div className="information-block bg-information-white p-0">
                                  <div className="information-wrap">
                                    <div key={tutor.u_id} className="information-holder align-items-center gap-2 myk__stu-profile-wrapper">
                                      <div
                                        data-testid="profileicon"
                                        className="circle-wrap circle-wrap-md bg-circle-twilight text-white user-profile"
                                      >
                                        {tutor.us_name[0]}
                                      </div>
                                      <div className="information-detail">
                                        <h3>{tutor.us_name}</h3>
                                        <p>{tutor.us_email}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                ))} 
                                </div>
                                </>
                              )}
                              <div className="myk__stu-course-info">
                                <h2>Course information</h2>
                                <ul>
                                  {courseOverviewData.courseDetails
                                    .filter(item => item.value !== 0)
                                    .map((item, index) => (
                                    <li key={index}>
                                      {item.icon} <span>{item.value ? <><strong>{item.value}</strong> {item.label}</> : item.label}</span>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                           </div>
                          </Col>
                        </Row>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="stu_report">
                        <CourseReport
                          courses={CoursesProgress}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="stu_test">
                        <TestJourney sections={sections} lectures={lectures} quiz={quiz} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="stu_announcement">
                        <CourseAnnouncements announcements={announcements} />
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
        </Col>
        <Col md={{ span:12, order: 0 }} lg={{ span:12, order: 0 }} xl={{ span:4, order: 0 }} className="myk__course-progress-col">
          <CourseProgressAccordion
            className="course-progress"
            lectures={lectureData}
            maxAttempts={3}
            enableSequentialProgress={true}
            onRetryClick={onRetryClick}
            onStartClick={onStartClick}
            onContinueClick={onContinueClick}
            onViewCertificateClick={onViewCertificateClick}
            certificateUrl={courseContent?.csa_lcrt_certificate_url}
            isCertificateOnlyArchived={courseContent?.csa_is_certificate_only_archived}
            resetResult={courseContent?.csa_lcrta_reset_result}
          />
           <Modal show={showCertificate} onHide={() => setShowCertificate(false)} size="lg" centered>
            <Modal.Header closeButton>
              <Modal.Title>Certificate</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
            {certificateUrl ? (
                <>
                  {certificateType === 'image' && (
                    <img
                      src={imageSrc('archive', `${courseContent?.id}/${certificateUrl}`, paths)}
                      alt="Certificate"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  )}
                </>
              ) : (
                <p>No certificate available.</p>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowCertificate(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </Col>
      </Row>
    </div>
    </>
    )}
    </>
  );
}

export default ArchiveDetails;

